
document.addEventListener("DOMContentLoaded", () => {
  const faqItems = document.querySelectorAll(".faqrs-item");
  faqItems.forEach(item => {
    const question = item.querySelector(".faqrs-question");
    const answer = item.querySelector(".faqrs-answer");
    question.addEventListener("click", () => {
      const isActive = item.classList.contains("faqrs-active");
      faqItems.forEach(i => {
        i.classList.remove("faqrs-active");
        i.querySelector(".faqrs-answer").style.maxHeight = null;
        i.querySelector(".faqrs-question").setAttribute("aria-expanded", "false");
      });
      if (!isActive) {
        item.classList.add("faqrs-active");
        answer.style.maxHeight = answer.scrollHeight + "px";
        question.setAttribute("aria-expanded", "true");
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector(".see-in-action-btn:not([data-modal-id])");
  if (!btn) return;

  btn.addEventListener("click", () => {
    const index = Number(btn.dataset.video) || 0;
    const slides = document.querySelectorAll(".swiper-slide-md video");

    if (slides.length === 0) return;

    const video = slides[index];

    if (!video) return;

    if (typeof video.click === "function") {
      video.click();  
    } else {
      video.play();
    }
  });
});
